<div class="platform-footer-container">
  <div class="content">
    <div class="links">
      <ng-content select="[links]"></ng-content>
    </div>
    <div class="spacer"></div>
    <div class="info">
      <div class="payment">
        <ng-content select="[payment]"></ng-content>
      </div>
      <div class="mission">
        <ng-content select="[mission]"></ng-content>
      </div>
    </div>
  </div>
</div>
